import { useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import CurrencyFormat from 'react-number-format';
import { Col, Row, Spinner } from 'reactstrap';
import CustomInputField from '../../../components/form/CustomInputField';
import CustomSelect from '../../../components/form/CustomSelect';
import Modal from '../../../components/modal/Modal';
import { useDict } from '../../../contexts/LanguageContext';
import { WithdrawReason } from '../../../utils/constants';
import { dateFormatter } from '../../../utils/dateHelper';
import { appendLocale } from '../../../utils/helper';
import { getWithdrawModalOptions } from '../src/fundApis';

const WithdrawModal = ({
    handleClose,
    isOpen,
    investmentNote,
    handleOpenConfirmationModal,
}) => {
    const dict = useDict();

    // const [eWalletBalance, setEWalletBalance] = useState(0);
    const [withdrawBankAccounts, setwithdrawBankAccounts] = useState([]);
    const [investmentAllocations, setInvestmentAllocations] = useState([]);
    const [withdrawReasonOptions, setWithdrawReasonOptions] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsFetching(true);
            getWithdrawModalOptions({ investment_note_id: investmentNote.id }, handlePostRetrieveWithdrawModalOptions);
            setIsFetching(false);
        }
    }, [isOpen]);

    const handlePostRetrieveWithdrawModalOptions = (response) => {
        const { data: responseData } = response.data;
        const bankAccounts = responseData.bank_accounts.map((account) => {
            return {
                value: account.id,
                label: account.bank[appendLocale('name')] + ' [Account No: ' + account.account_no + ' - ' + account.account_owner_name + ']',
            }
        });

        const allocations = responseData.investment_note_allocations.map((allocation) => {
            return {
                value: allocation.id,
                label: "[" + dateFormatter(allocation.created_at) + "] ฿" + allocation.amount.toLocaleString(),
            }
        });

        const withdrawalReasons = responseData.withdrawal_reasons.map((reason) => {
            return {
                value: reason.id,
                label: reason[appendLocale('name')],
            }
        });

        setwithdrawBankAccounts(bankAccounts);
        setInvestmentAllocations(allocations);
        setWithdrawReasonOptions(withdrawalReasons);
    }

    const withdrawValidate = (values) => {
        const errors = {};
        if (!values.bank_account_id) {
            errors.bank_account_id = dict.bankAccountSelectEmpty;
        }
        if (!values.investment_note_allocation_id) {
            errors.investment_note_allocation_id = dict.investmentAllocationSelectEmpty;
        }
        if (!values.withdrawal_reason_id) {
            errors.withdrawal_reason_id = dict.reasonSelectEmpty;
        }

        return errors;
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            title={dict.withdraw}
            headerType="invest-withdrawal"
            onCancel={handleClose}
            submitBtnProps={{
                form: 'withdrawal-form',
                disabled: isLoading,
            }}
            cancelText={dict.cancel}
            submitText={dict.confirm}
            testID="withdrawModal"
            submitShown
        >
            {isFetching ? (
                <div className="d-flex justify-content-center">
                    <Spinner />
                </div>
            ) : (
                <div data-cy="modal__content">
                    {/* <Row className="text-center mb-4 g-0">
                        <Col>
                            <p className="h6">{dict.totalCashBalance}</p>
                            <p className="h5">{`฿ ${
                                eWalletBalance?.e_wallet_balance || 0
                            }`}</p>
                        </Col>
                    </Row> */}

                    <Row className="text-center mb-2 g-0">
                        <Col>
                            <p className="h5 text-bold">{dict.investmentNote}:</p>
                        </Col>
                        <Col>
                            <p className="h5 text-success">{investmentNote?.name}</p>
                        </Col>
                    </Row>
                    <Row className="text-center mb-4 g-0">
                        <Col>
                            <p className="h5 text-bold">{dict.committedAmount}:</p>
                        </Col>
                        <Col>
                            <CurrencyFormat
                                value={parseFloat(
                                    investmentNote?.invest_amount || 0
                                ).toFixed(2)}
                                displayType="text"
                                thousandSeparator
                                prefix="฿ "
                                className="text-success"
                            />
                        </Col>
                    </Row>

                    <Form
                        initialValues={{
                            bank_account_id: '',
                            investment_note_allocation_id: '',
                            withdrawal_reason_id: '',
                        }}
                        onSubmit={handleOpenConfirmationModal}
                        validate={withdrawValidate}
                    >
                        {({ handleSubmit, values }) => (
                            <form
                                id="withdrawal-form"
                                className="form form-invest form-custom"
                                style={{ textAlign: 'left' }}
                                onSubmit={handleSubmit}
                            >
                                <Field name="bank_account_id">
                                    {({ input, meta }) => (
                                        <div className="form__form-group">
                                            <div
                                                className="form__form-group-field"
                                                data-private
                                            >
                                                <CustomSelect
                                                    input={input}
                                                    meta={meta}
                                                    options={
                                                        withdrawBankAccounts ||
                                                        []
                                                    }
                                                    placeholder={
                                                        dict.selectBankAccount
                                                    }
                                                    data-cy="withdraw__select--bankAcc"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Field>
                                <Field name="investment_note_allocation_id">
                                    {({ input, meta }) => (
                                        <div className="form__form-group">
                                            <div
                                                className="form__form-group-field"
                                                data-private
                                            >
                                                <CustomSelect
                                                    input={input}
                                                    meta={meta}
                                                    options={
                                                        investmentAllocations || []
                                                    }
                                                    placeholder={
                                                        dict.selectInvestmentAllocation
                                                    }
                                                    data-cy="withdraw__select--bankAcc"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Field>
                                <Field name="withdrawal_reason_id">
                                    {({ input, meta }) => (
                                        <div className="form__form-group">
                                            <div
                                                className="form__form-group-field"
                                                data-private
                                            >
                                                <CustomSelect
                                                    input={input}
                                                    meta={meta}
                                                    options={
                                                        withdrawReasonOptions ||
                                                        []
                                                    }
                                                    placeholder={
                                                        dict.selectReasonForWithdrawal
                                                    }
                                                    data-cy="withdraw__select--withdrawalReasons"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Field>
                                {values.withdrawal_reason_id === WithdrawReason.Other && (
                                    <div className="form__form-group">
                                        <div
                                            className="form__form-group-field"
                                            style={{ marginTop: '10px' }}
                                        >
                                            <Field name="description">
                                                {({ input, meta }) => (
                                                    <CustomInputField
                                                        input={input}
                                                        meta={meta}
                                                        type="text"
                                                        placeholder={dict.descriptionPlaceholder}
                                                        inputClassName="invest-now-form__input"
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                )}
                            </form>
                        )}
                    </Form>
                </div>
            )}
        </Modal>
    );
};

export default WithdrawModal;
